import { crypto_box_keypair, to_base64, KeyPair, crypto_box_seal, crypto_box_seal_open, from_base64, crypto_secretbox_open_easy, crypto_secretbox_easy } from 'libsodium-wrappers';

declare function unescape(s: string): string;
export class Elliptic {

    /*
        crea coppia di chiavi e torna array con private, public in uint8
    */
    static createkeypair() {
        let keypair = crypto_box_keypair('uint8array');
        return keypair;
    }

    /*
        crea coppia di chiavi e torna array con private, public in base64
    */
    static b64createkeypair() {
        let keypair = crypto_box_keypair('uint8array');
        return {
            'privateKey': to_base64(keypair.privateKey),
            'publicKey': to_base64(keypair.publicKey)
        };
    }


    /*
        crea coppia di chiavi e torna array con private, public in base64
    */
    static b64createkeypairPHP() {
        let keypair = crypto_box_keypair('uint8array');
        return {
            'privateKey': Elliptic.my_to_base64(keypair.privateKey),
            'publicKey': Elliptic.my_to_base64(keypair.publicKey)
        };
    }



    /*
        converte una coppia di chiavi e torna array con private, public in base64
    */
    static b64convertkeypair(keypair: KeyPair) {
        return {
            'privateKey': to_base64(keypair.privateKey),
            'publicKey': to_base64(keypair.publicKey)
        };
    }

    /*
        encode ellittico con publickey formato uint8 torna uint8
    */
    static enc(message: string, publicKey: Uint8Array) {
        let ciphertext = crypto_box_seal(message, publicKey);
        return ciphertext;
    }


    /*
        encode ellittico con publickey formato base64 torna base64
    */
    static b64encPHP(message: string, b64nonce: string, b64key: string) {
        let nonce = Elliptic.my_from_base64(b64nonce);
        let key = Elliptic.my_from_base64(b64key);
        return Elliptic.my_to_base64(crypto_secretbox_easy(message, nonce, key));
    }


    /*
        encode ellittico con publickey formato base64 torna base64
    */
    static b64encPHPWithoutNonce(message: string, b64key: string) {

        let publickey = Elliptic.my_from_base64(b64key);
        let ciphertext = crypto_box_seal(message, publickey);
        return Elliptic.my_to_base64(ciphertext);
    }


    /*
        encode ellittico con publickey formato base64 torna base64
    */
    static b64enc(message: string, b64publicKey: string) {
        let publickey = from_base64(b64publicKey);
        let ciphertext = crypto_box_seal(message, publickey);
        return to_base64(ciphertext);
    }

    /*
        decode ellittico con ciphertext formato uint8 publickey  uint8 torna string
    */
    static dec(ciphertext: Uint8Array, publicKey: Uint8Array, privateKey: Uint8Array) {
        let message = crypto_box_seal_open(ciphertext, publicKey, privateKey, 'text');
        return message;
    }

    /*
        decode ellittico con ciphertext formato base64 keys base64 torna base64
    */
    static b64decPHP(b64ciphertext: string, b64nonce: string, b64key: string) {
        let nonce = Elliptic.my_from_base64(b64nonce);
        let key = Elliptic.my_from_base64(b64key);
        let ciphertext = Elliptic.my_from_base64(b64ciphertext);

        return crypto_secretbox_open_easy(ciphertext, nonce, key, 'text');

    }




    /*
        decode ellittico con ciphertext formato base64 keys base64 torna base64
    */
    static b64dec(b64ciphertext: string, b64publicKey: string, b64privatekey: string) {
        let publicKey = from_base64(b64publicKey);
        let privateKey = from_base64(b64privatekey);

        let ciphertext = from_base64(b64ciphertext);

        let message = crypto_box_seal_open(ciphertext, publicKey, privateKey, 'text');
        return message;
    }

    static b64decPHPOpen(b64ciphertext: string, b64publicKey: string, b64privatekey: string) {
        let publicKey = Elliptic.my_from_base64(b64publicKey);
        let privateKey = Elliptic.my_from_base64(b64privatekey);

        let ciphertext = Elliptic.my_from_base64(b64ciphertext);

        let message = crypto_box_seal_open(ciphertext, publicKey, privateKey, 'text');
        return message;
    }

    static my_from_base64(b64Data: any) {

        var binary_string = window.atob(b64Data);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes;

    }

    static my_to_base64(buffer: any) {


        var binary = '';
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    static my_base64_encode(string: string) {

        return window.btoa(unescape(encodeURIComponent(string)));

    }




}


// WEBPACK FOOTER //
// ./src/app/theme/pages/default/cybersecurity/elliptic.encryption.ts